module.exports = __webpack_public_path__ + "img/loading.261a5a68.gif";